<script setup lang="ts">
import { GemstoneMenuBlock } from '@interfaces/menu.interface'
import BlockSection from './BlockSection.vue'
import { Link } from '@inertiajs/vue3'

defineProps<{
    block: GemstoneMenuBlock,
}>()
</script>

<template>
    <BlockSection :title="$t('components.menu.catalog.stone')">
        <ul class="space-y-1.5">
            <li
                v-for="(item, itemIdx) in block.items"
                :key="itemIdx"
            >
                <Link
                    :href="item.url"
                    class="flex items-center transition-colors rounded-lg group"
                >
                <div class="mr-2 rounded-lg bg-grayscale-50 w-9 h-9 shrink-0">
                    <img
                        :srcset="`/images/menu/gemstones/${item.type}.png, /images/menu/gemstones/${item.type}@2x.png 2x, /images/menu/gemstones/${item.type}@3x.png 3x`"
                        :src="`/images/menu/gemstones/${item.type}.png`"
                        :alt="item.type"
                        class="w-full h-full p-2 transition-transform duration-300 transform group-hover:scale-110"
                        loading="lazy"
                        importance="auto"
                    >
                </div>
                <span class="truncate text-grayscale-800 group-hover:text-primary-800">{{ item.name }}</span>
                </Link>
            </li>
        </ul>
    </BlockSection>
</template>
